module.exports = __webpack_public_path__ + "static/media/Dong_song_icon_200px.5c67b8b1.png";